export interface DuetFonts {
  [key: `--font-${string}`]: string;
}

type Props = {
  fonts: DuetFonts | undefined;
};

const Fonts: React.FC<Props> = ({ fonts }) => {
  if (!fonts) {
    return null;
  }

  const fontStyles = Object.entries(fonts)
    .map(([key, value]) => `${key}: ${value};`)
    .join("");

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
          :root {
            ${fontStyles}
          }
        `,
      }}
    />
  );
};

export default Fonts;
